<template>
  <b-container fluid class="theme-red">
    <div class="page-header">
      <Navbar text="Dashboard" />
    </div>

    <section>
      <h2>Welcome to the Harpra Platform</h2>

      <p>
        Augmented & Virtual Reality are both powerful technologies. When united under one Platform they become
        practical and versatile tools for everyone.
      </p>

      <p>
        Evolve your traditional practices with the Harpra Platform.
      </p>

      <h2>Get Started</h2>

      <b-button variant="primary" :to="{ name: 'Models', query: { add: true } }" class="mr-3">
        Upload Viewer Models
      </b-button>

      <b-button variant="primary" :to="{ name: 'CompanionModels', query: { add: true } }" class="mr-3">
        Upload Companion Models
      </b-button>

      <b-button variant="primary" :to="{ name: 'WebARModels', query: { add: true } }" class="mr-3">
        Upload Web AR Models
      </b-button>

      <b-button variant="primary" :to="{ name: 'Support' }" class="mr-3">
        Get Support Help
      </b-button>
    </section>
  </b-container>
</template>

<script>
import Navbar from "../Navigation/Navbar";
export default {
  name: "Dashboard",
  components: {
    Navbar,
  },
};
</script>
